import React, { useState } from "react";
import executeRequest from "../../../../modules/request.js";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import PlainEditor from "../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import { parse } from "query-string";
export default function Login(props) {
    var _a;
    const { preLink } = parse(location.search);
    const [gallery, setGallery] = useState((_a = preLink) !== null && _a !== void 0 ? _a : "");
    const [password, setPassword] = useState("");
    const [result, setResult] = useState("");
    const { content } = props;
    return (React.createElement("div", { className: props.classNames + " login-box-container" },
        React.createElement("h3", { className: "title" }, content.title),
        preLink !== undefined ?
            React.createElement(React.Fragment, null, "Aby wej\u015B\u0107 do galerii podaj has\u0142o")
            : content.bodyMessage ?
                React.createElement(React.Fragment, null,
                    React.createElement(PlainEditor, { editable: false, onChange: () => { }, withoutLabel: true, label: "", example: content.bodyMessage }))
                : React.createElement(React.Fragment, null, "Aby wej\u015B\u0107 do galerii, podaj nazw\u0119 oraz has\u0142o."),
        preLink === undefined && (React.createElement(React.Fragment, null,
            React.createElement("input", { type: "text", name: "galeria", autoComplete: "off", placeholder: "Podaj nazw\u0119", value: gallery, onChange: (event) => setGallery(event.target.value) }))),
        React.createElement("input", { type: "password", name: "password", autoComplete: "off", onChange: (event) => setPassword(event.target.value), placeholder: "Podaj has\u0142o" }),
        React.createElement(Button, { text: "Wejd\u017A", value: "go_to_gallery", version: "classic", onClick: async () => {
                const response = await executeRequest(`../api/public/users/gallery/open?link=${gallery}&password=${password}`, "GET", {});
                if (response.status == 404) {
                    setResult("Podane dane są nieprawidłowe");
                    return;
                }
                if (response.status == 423) {
                    setResult("Ta galeria nie jest dostępna");
                    return;
                }
                if (response.status === 403) {
                    return setResult("Ta galeria jest zarchiwizowana");
                }
                if (response.status == 200) {
                    props.onSuccesfullLogin(response.consents);
                    setResult("");
                    return;
                }
            } }),
        React.createElement("span", { style: { color: "red" } }, result)));
}
